import { useState } from 'react';

const useDeleteFile = () => {
    const [isDeleting, setIsDeleting] = useState(false);
    const [error, setError] = useState(null);

    const deleteFile = async (photoUrl) => {
        setIsDeleting(true);
        setError(null);

        try {
            const fileKey = photoUrl;
            const response = await fetch('/api/media/delete_file', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ fileKey }),
            });

            if (response.ok) {
                return { success: true };
            } else {
                throw new Error('Failed to delete file');
            }
        } catch (err) {
            console.error('Error deleting file:', err);
            setError(err.message);
        } finally {
            setIsDeleting(false);
        }
    };

    return { deleteFile, isDeleting, error };
};

export default useDeleteFile;
